<div>
  <div>
    <div class="loader">
      <mat-spinner *ngIf="dataLoading" diameter="30"></mat-spinner>
    </div>
  </div>
  <div>
    <h1 mat-dialog-title>{{'module-assignment.hotkeys.add_group_details' | translate}}</h1>
    <div id="divDialogContent" mat-dialog-content [formGroup]="frmHotKey">
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-15 u-margin-bottom-15">
        <div fxFlex="60">
          <div fxLayout="row wrap" fxLayoutGap="20px grid">
            <div fxFlex="30">
              <p>
                {{ "module-assignment.hotkeys.displayName" | translate }}
                <span style="color: red;">*</span>
              </p>
            </div>
            <div fxFlex="70">
              <mat-form-field class="mat-block" floatLabel="never">
                <input matInput formControlName="displayName" />
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutGap="20px grid">
            <div fxFlex="30">
              <p>
                {{ "module-assignment.hotkeys.add_thumbnail" | translate }}
              </p>
            </div>
            <div fxFlex="70">
              <button
                type="button"
                mat-raised-button
                (click)="fileInput.click()"
                [disabled]="action==='view'"
              >
                Choose File
              </button>
              <input hidden (change)="onFileChange($event)" #fileInput type="file" />
            </div>
            <div class="u-text-left">
              <!-- <p>
                <b>
                  {{'module-assignment.hotkeys.note' | translate}}
                </b>
              </p> -->
              <p class="list">
                <b>
                  {{'module-assignment.hotkeys.size_note' | translate}}
                </b>
              </p>
              <p class="list">
                <b>
                  {{'module-assignment.hotkeys.ratio_note' | translate}}
                </b>
              </p>
            </div>
          </div>
        </div>
        <div fxFlex="40" class="image-container">
          <div *ngIf="frmHotKey.get('image').value" class="image-box">
            <img id="product-image" [src]="frmHotKey.get('image').value" class="product-image" />
          </div>
        </div>
      </div>
    </div>
    <!-- table -->
    <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-15 u-margin-bottom-15">
      <div fxFlex="100">
        <mat-card>
          <mat-card-header>
            <mat-card-title>
              {{ "module-assignment.hotkeys.title" | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div
              fxLayout="row wrap"
              fxLayoutGap="20px grid"
              class="u-margin-top-15 u-margin-bottom-15"
            >
              <!-- <div fxFlex="50">
                <mat-form-field class="mat-block" floatLabel="never">
                  <input
                    matInput
                    [placeholder]="'module-assignment.hotkeys.search' | translate"
                    #input
                    (keyup)="search()"
                  />
                </mat-form-field>
              </div> -->
              <div fxFlex="100">
                <button
                  mat-icon-button
                  class="pull-right"
                  [matTooltip]="'module-assignment.hotkeys.add' | translate"
                  matTooltipPosition="above"
                  (click)="openAddHotkeyDialog()"
                  [disabled]="action==='view'"
                >
                  <mat-icon>add_circle</mat-icon>
                </button>
              </div>
            </div>
            <div
              fxLayout="row wrap"
              fxLayoutGap="20px grid"
              class="u-margin-top-15 u-margin-bottom-15"
            >
              <div
                fxFlex="100"
                class="table-container"
                [ngStyle]="{'maxHeight': maxHeight, 'display': 'flex'
              ,'flex-direction': 'column'}"
              >
                <div class="table-scroll">
                  <table mat-table #ebasketHotkeysTable [dataSource]="productDataSource" matSort>
                    <ng-container matColumnDef="position">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        <!-- {{ "module-assignment.hotkeys.position" | translate }} -->
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{element.position}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="SKU">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ "module-assignment.hotkeys.sku" | translate }}
                      </th>
                      <td #matCell mat-cell *matCellDef="let element">{{ element.SKU }}</td>
                    </ng-container>

                    <ng-container matColumnDef="displayName">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ "module-assignment.hotkeys.displayName" | translate }}
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{element.displayName}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef>
                        {{ "module-assignment.hotkeys.action" | translate }}
                      </th>
                      <td mat-cell *matCellDef="let element">
                        <button
                          mat-icon-button
                          [matTooltip]="'module-assignment.hotkeys.edit' | translate"
                          matTooltipPosition="above"
                          (click)="editRow(element,'edit')"
                          [disabled]="action==='view'"
                        >
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button
                          mat-icon-button
                          [matTooltip]="'module-assignment.hotkeys.view' | translate"
                          matTooltipPosition="above"
                          (click)="editRow(element,'view')"
                        >
                          <mat-icon>remove_red_eye</mat-icon>
                        </button>
                        <button
                          mat-icon-button
                          [matTooltip]="'module-assignment.hotkeys.delete' | translate"
                          matTooltipPosition="above"
                          (click)="removeRow(element)"
                          [disabled]="action==='view'"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="productColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: productColumns;"></tr>
                  </table>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div id="divDialogAction" mat-dialog-actions class="pull-right">
      <button
        id="btnYes"
        mat-flat-button
        mat-dialog-close="yes"
        cdkFocusInitial
        color="primary"
        [disabled]="frmHotKey.invalid || action==='view'"
        (click)="onSave()"
      >
        {{'module-assignment.hotkeys.ok' | translate}}
      </button>
      <button id="btnNo" mat-flat-button mat-dialog-close="no" color="warn" (click)="onCancel()">
        {{'module-assignment.hotkeys.cancel' | translate}}
      </button>
    </div>
  </div>
</div>
